"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[76],{

/***/ 60076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionPeople": function() { return /* binding */ SectionPeople; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);



const SectionPeopleContainer = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .SectionWrapper */ .Uq, {
    "@lg": {
        paddingInline: 30
    }
});
const SectionPeopleTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("h2", {
    marginBlockEnd: 96,
    projectFont: "heading02",
    color: "$white",
    textAlign: "center",
    marginInline: "auto",
    "@lg": {
        maxWidth: 500
    }
});
const PeopleGrid = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    gap: 20,
    paddingBlock: 24,
    "@lg": {
        gridTemplateColumns: "repeat(3, auto)",
        justifyContent: "center",
        gridAutoFlow: "column"
    }
});
const Card = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    position: "relative",
    overflow: "hidden",
    borderRadius: 20
});
const SectionPeopleCardContainer = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(Card, {
    display: "flex",
    flexDirection: "column",
    gap: "30px 0",
    padding: 20,
    backgroundColor: "#212121",
    justifyContent: "start",
    "@lg": {
        maxWidth: 440,
        minHeight: 440
    }
});
const CardContent = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    projectFont: "body03",
    color: "$white",
    alignSelf: "flex-end"
});
const CardMedia = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    overflow: "hidden",
    borderRadius: 8
});
const CardDetailsName = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("span", {
    display: "block",
    projectFont: "body03",
    color: "$gray300",
    alignSelf: "flex-end"
});
const CardDetailsPosition = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("span", {
    display: "block",
    projectFont: "body03",
    color: "$gray300",
    alignSelf: "flex-end"
});
const DesktopVisibilityContainer = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "none",
    "@lg": {
        display: "block"
    }
});
const MobileVisibilityContainer = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "block",
    "@lg": {
        display: "none"
    }
});
const PeopleCard = (param)=>{
    let { card , priority  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SectionPeopleCardContainer, {
        children: [
            card.media && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardMedia, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                    ...card.media,
                    priority: priority,
                    objectFit: "contain",
                    sizes: "(min-width: 1024px) 33vw, 100vw"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    card.content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardContent, {
                        children: card.content
                    }),
                    (card === null || card === void 0 ? void 0 : card.name) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardDetailsName, {
                        children: card.name
                    }),
                    (card === null || card === void 0 ? void 0 : card.position) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardDetailsPosition, {
                        children: card.position
                    })
                ]
            })
        ]
    });
};
function SectionPeople(param) {
    let { title , cards , priority , spacing , topBorder  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SectionPeopleContainer, {
        type: spacing || "DEFAULT",
        topBorder: topBorder,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionPeopleTitle, {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DesktopVisibilityContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PeopleGrid, {
                    children: cards === null || cards === void 0 ? void 0 : cards.map((card)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PeopleCard, {
                            card: card,
                            priority: priority
                        }, card._key);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileVisibilityContainer, {
                children: !!(cards === null || cards === void 0 ? void 0 : cards.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Slider */ .iR, {
                    isFullWidth: true,
                    children: cards.map((card)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PeopleCard, {
                            card: card,
                            priority: priority
                        }, card._key);
                    })
                })
            })
        ]
    });
}


/***/ })

}]);